import React, {useEffect} from 'react'
import styles from './AuthCompleted.module.scss'
import optionsStore from '../../../zustand/optionsStore'
import userStore from '../../../zustand/userStore'
import { useLocation, useNavigate } from 'react-router-dom'

const AuthCompleted = () => {
    let encryptedToken = useLocation().search.split('?encryptedToken=')[1]
    let logIn = userStore(state => state.logIn)
    let navigate = useNavigate()
    useEffect(() => {
        logIn(encryptedToken, navigate)
    }, [])
    const lng = optionsStore(state => state.language)      
    return (
        <div className={styles.wrapper}>
            {/* <h1>{lng.logIn.authCompleted}</h1> */}
            {/* <svg width="50%" height="50%" version="1.1" id="L5" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"
                viewBox="0 0 100 100" enable-background="new 0 0 0 0">
                <circle fill="#fff" stroke="none" cx="6" cy="50" r="6">
                    <animateTransform 
                    attributeName="transform" 
                    dur="1s" 
                    type="translate" 
                    values="0 15 ; 0 -15; 0 15" 
                    repeatCount="indefinite" 
                    begin="0.1"/>
                </circle>
                <circle fill="#fff" stroke="none" cx="30" cy="50" r="6">
                    <animateTransform 
                    attributeName="transform" 
                    dur="1s" 
                    type="translate" 
                    values="0 10 ; 0 -10; 0 10" 
                    repeatCount="indefinite" 
                    begin="0.2"/>
                </circle>
                <circle fill="#fff" stroke="none" cx="54" cy="50" r="6">
                    <animateTransform 
                    attributeName="transform" 
                    dur="1s" 
                    type="translate" 
                    values="0 5 ; 0 -5; 0 5" 
                    repeatCount="indefinite" 
                    begin="0.3"/>
                </circle>
            </svg> */}
        </div>
    )
}

export default AuthCompleted